import React, { FC } from 'react'

import clsx from 'clsx'
import { motion } from 'motion/react'

import styles from './GlassColumn.module.scss'
import { GlassColumnProps } from './GlassColumn.types'

export const GlassColumn: FC<GlassColumnProps> = ({ className, ...props }) => {
  return (
    <motion.div
      layout
      className={clsx(styles.glassColumn, className)}
      {...props}
      transition={{ layout: { type: 'spring', damping: 30, stiffness: 200 } }}
    />
  )
}
